import React, { memo, useEffect, useState, useRef, useCallback } from 'react';
import { Pressable, View, Platform, Text } from 'react-native';
import { FlatList } from 'react-native-gesture-handler';
import PrimaryMenu from './PrimaryMenu';
import { useSelector } from 'react-redux';
import { DefaultRootState } from '@reduxLocal/persistState';
import superAdmin from './DynamicMenuList';
import { isTablet } from 'react-native-device-info';

const PrimaryList = () => {
  const menuType = useSelector((state: DefaultRootState) => state.navigation.menuType);
  const defaultMenuArray = superAdmin;
  const filteredMenu = defaultMenuArray.filter(menu => menu.menuType === menuType);
  const returnMenu = filteredMenu[0].menu;
  const [newMenuArray, setNewMenuArray] = useState(returnMenu);
  const menuRef = useRef(null);
  const [flatListHeight, setFlatListHeight] = useState(0);
  const [isScrollable, setIsScrollable] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    setNewMenuArray(returnMenu);
  }, [menuType]);

  const _renderPrimaryMenu = ({ item, index }) => {
    return item.primary && (
      <View style={{ elevation: 1, left: 0, overflow: "visible", minHeight: 30 }}>
        <PrimaryMenu item={item} />
      </View>
    )
  }

  const handleScroll = useCallback((event) => {
    const { contentOffset, contentSize, layoutMeasurement } = event.nativeEvent;
    const isAtEnd = contentOffset.y >= (contentSize.height - layoutMeasurement.height - 10);
    setIsAtBottom(isAtEnd);
  }, []);

  const handleContentSizeChange = useCallback((contentWidth, contentHeight) => {
    const scrollable = contentHeight > flatListHeight;
    setIsScrollable(scrollable);
    // If content is not scrollable, we're always "at bottom"
    if (!scrollable) {
      setIsAtBottom(true);
    }
  }, [flatListHeight]);

  return (
    <View style={{ flex: 1 }} pointerEvents="box-none">
      <FlatList
        data={newMenuArray}
        showsVerticalScrollIndicator={Platform.OS !== 'web'}
        nestedScrollEnabled={true}
        scrollEnabled={true}
        ref={menuRef}
        centerContent={false}
        style={{ flex: 1 }}
        contentContainerStyle={{
          paddingBottom: Platform.select({ ios: isTablet ? 10 : 8, android: 28 }),
          gap: Platform.select({ ios: isTablet ? 4 : 2, android: 2 }),
          paddingTop: 0
        }}
        renderItem={_renderPrimaryMenu}
        keyExtractor={(item) => item.id}
        onScroll={handleScroll}
        scrollEventThrottle={16}
        onContentSizeChange={handleContentSizeChange}
        onLayout={(event) => {
          setFlatListHeight(event.nativeEvent.layout.height);
        }}
        removeClippedSubviews={false}
        bounces={Platform.OS === 'ios'}
        alwaysBounceVertical={false}
        keyboardShouldPersistTaps="handled"
      />
      {isScrollable && !isAtBottom && Platform.OS != 'web' && (
        <Pressable
          onPress={() =>
            menuRef.current?.scrollToEnd({ animated: true })
          }
          style={{ position: 'absolute', bottom: 0, right: 10, backgroundColor: 'rgba(0,0,0,0.5)', borderRadius: 15, padding: 5 }}
          pointerEvents="box-only"
        >
          <Text style={{ color: 'white', fontSize: 12 }}>↓</Text>
        </Pressable>
      )}
    </View>
  )
}
export default memo(PrimaryList);